export default "/assets/images/mila-air-specs-sm.c03228ada8a9506e.webp";